<template>
  <div class="select-bd">
    <div class="select-value" @click='toggle'>
      <span class="line1" v-if="selectData">{{listProp? selectData[listProp] : selectData}}</span>
      <span class="holder line1" v-else>{{placeholder}}</span>
      <i class="icon icon-down"></i></div>
    <div class="select-list" v-if="showSelectList&&list.length>0">
      <ul>
        <li @click="selectItem(item)" v-for="item in list">{{ listProp? item[listProp] : item }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
/**
   * @param list [Array] 下拉选择列表
   * @param listProp [String] 下拉选择列表显示的属性名
   * @param value [String，Object] v-model绑定值，绑定值类型根据列表类型决定
   * @param change [Function] 选择变化时触发事件
   * @describe 可以配合tField组件一起使用，但此组件和selectbox,selectitem没有任何关系
   *
   * @example
   *
    <t-select :list="selectList" list-prop="name" v-model=""></t-select>
   */

export default {
  name: 'tSelect',
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    listProp: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: [Object, String],
  },
  data() {
    return {
      selectData: this.value,
      showSelectList: false,
    };
  },
  watch: {
    value(val) {
      this.selectData = val; // 新增value的watch，监听变更并同步到currentValue上,适用于外部操作的变更
    },
  },
  mounted: function () {
    document.addEventListener('click', this.isBlur);
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.isBlur);
  },
  methods: {
    isBlur: function (e) {
      // 判断元素节点A是否包含B元素节点ANode.contains(BNode)
      if (!this.$el.contains(e.target)) this.showSelectList = false;
    },
    toggle: function () {
      this.showSelectList = !this.showSelectList;
    },
    selectItem: function (item) {
      this.toggle();
      this.$emit('input', item);
      this.$emit('change', item);
    },
  },
};

</script>
<style lang="scss">
.select-bd {
  height: 36px;
  line-height: 34px;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  .select-value {
    color: #4D4D4D;
    font-size: 15px;
    padding-left: 8px;
    display: flex;
    span {
      flex: 1;
      overflow: hidden;
      display: block;
      height: 34px;
      width: 0;
    }
    i {
      font-size: 16px;
      margin-right: 2px;
      color: #4D4D4D;
    }
    .holder {
      color: #B0B1AC;
    }
  }
  .select-list {
    position: absolute;
    top: 33px;
    left: -1px;
    right: -1px;
    z-index: 8;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 1px solid #f1f1f1;
    background-color: #ffffff;
    ul li {
      text-align: center;
      line-height: 38px;
      font-size: 15px;
      color: #4D4D4D;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/select.vue